<div
  [@quoteEnterAnimation]
  [@.disabled]="!animateQuotes"
  class="quote-container"
  [ngClass]="{ 'quote-container--expired': row.outdated }"
>
  <div class="table-column">
    <div
      class="table-row"
      *ngIf="showVolSpreadLine && (volBased || row.status !== 'Indicative')"
    >
      <div class="volspread volspread--{{ position }}">
        <ng-container
          *ngTemplateOutlet="
            volSpread;
            context: {
              side: row.vol[position],
              currency: row.bidAsk.currency,
              premiumStyle: row.premiumStyle,
              left: position === 'left'
            }
          "
        ></ng-container>
      </div>
    </div>
  </div>

  <div
    class="table-row table-row--banks {{ row.status || '' }}"
    [ngClass]="{ 'hide-indicative': maybeHideIndicativeRow() }"
    [@quoteActionAnimation]="row.status"
    *ngIf="frozenQuote || row.timeLimit >= currentTimestamp || !row.timeLimit"
  >
    <div
      class="table-row__data-box--whole-row"
      [ngClass]="{
        'table-row__data-box--whole-row--ask': side === 'offer'
      }"
    >
      <div
        class="table-row__data-box--whole-row__top"
        [ngClass]="{
          'table-row__data-box--whole-row__top--ask': side === 'offer'
        }"
      >
        <ng-container
          *ngIf="row.status !== 'Indicative' && !useSingleProviderDetailedView"
        >
          <ng-container
            *ngTemplateOutlet="
              providerNameStatus;
              context: { row: row, side: side, i: index }
            "
          ></ng-container>
        </ng-container>

        <div class="table-row__data-box--whole-row__top__right-side">
          <div class="table-row__data-box--whole-row__top__right-side__data">
            <ng-container *ngIf="side === 'offer'">
              <ng-container
                *ngTemplateOutlet="
                  rfqButton;
                  context: { row: row, type: 'offer', i: index }
                "
              ></ng-container>
            </ng-container>

            <div
              class="table-row__data-box table-row__data-box--sub"
              *ngIf="
                row.status !== 'Indicative' && !useSingleProviderDetailedView
              "
            >
              <span
                class="table-row__vol"
                *ngIf="
                  !useSingleProviderDetailedView &&
                  row.vol?.[position] &&
                  showInlineVol
                "
              >
                <ng-container *ngFor="let vol of row.vol[position]">
                  <label [ngClass]="vol.buyOrSell" *ngIf="vol?.value">
                    {{ vol?.value * 100 | number: '1.2-2' }}
                  </label>
                </ng-container>
              </span>
            </div>
            <ng-container *ngIf="side === 'bid'">
              <ng-container
                *ngTemplateOutlet="
                  rfqButton;
                  context: { row: row, type: 'bid', i: index }
                "
              ></ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="table-row__data-box--whole-row__bottom">
        <ng-container
          *ngTemplateOutlet="timerblock; context: { row: row }"
        ></ng-container>
      </div>
    </div>
  </div>
</div>
<!-- VOL SPREAD -->
<ng-template
  #volSpread
  let-side="side"
  let-currency="currency"
  let-left="left"
  let-premiumStyle="premiumStyle"
>
  <ng-container *ngFor="let vol of side; let idx = index">
    <ng-container *ngIf="vol">
      <div *ngIf="left"></div>
      <div
        class="dir {{ vol.premium.buyOrSell }}"
        [ngClass]="{ indicative: row.status === 'Indicative' }"
      >
        Leg {{ idx + 1 }} Client {{ vol.premium.payOrReceive | lowercase }}s
      </div>
      <div
        class="ccy {{ vol.premium.buyOrSell }}"
        [ngClass]="{ indicative: row.status === 'Indicative' }"
      >
        {{ currency }}
      </div>
      <div
        class="amount {{ vol.premium.buyOrSell }}"
        [ngClass]="{ indicative: row.status === 'Indicative' }"
      >
        {{ formatPremium(vol.premium.value, premiumStyle, true) }}
      </div>
      <div
        class="vol {{ vol.premium.buyOrSell }}"
        [ngClass]="{ indicative: row.status === 'Indicative' }"
      >
        (Vol: {{ vol?.value * 100 | number: '1.4-4' }})
      </div>
      <div *ngIf="!left"></div>
    </ng-container>
  </ng-container>
</ng-template>

<!-- VOL PREMIUM -->
<ng-template #volBasedPremium let-premium="premium" let-currency="currency">
  <span
    class="bank-button-text"
    *ngIf="premium?.percentBase && currency === baseCurrency"
  >
    {{ premium?.percentBase | number: '1.3-3' }}%
    {{ row.quotedPremiumSection?.isPips ? 'pips' : currency }}
  </span>
  <span
    class="bank-button-text"
    *ngIf="premium?.pipsTerm && currency === termPair"
  >
    {{ premium.pipsTerm * forwardPointsMultiplier | number: '1.2-2' }}
    {{ currency }}
  </span>
</ng-template>

<!-- TIMER BLOCK -->
<ng-template #timerblock let-row="row">
  <span
    class="table-row__rfe-status"
    *ngIf="
      row.status === 'ConfirmRFESent' ||
      row.status === 'ConfirmRFEAccept' ||
      row.status === 'ConfirmRFEDecline'
    "
  >
    <div class="table-row__rfe-status__hline"></div>
    <ng-container [ngSwitch]="row.status">
      <span
        class="response-block response-sent"
        *ngSwitchCase="'ConfirmRFESent'"
      >
        <span class="spinner spinner-sm" *ngIf="rfqRunning"> Loading... </span>
        <span class="response-text">RFE Sent</span>
      </span>
      <span
        class="response-block response-success"
        *ngSwitchCase="'ConfirmRFEAccept'"
      >
        <cds-icon class="check" shape="check"></cds-icon>
        <span class="response-text response-text--success"> Trade Done </span>
        <ng-container *ngIf="pingOnce()"></ng-container>
      </span>
      <span
        class="response-block response-declined"
        *ngSwitchCase="'ConfirmRFEDecline'"
      >
        <cds-icon class="declined" shape="ban"></cds-icon>
        <span class="response-text response-text--declined">
          RFE Declined
        </span>
      </span>
    </ng-container>
  </span>
</ng-template>

<ng-template #hedgeQuotes let-row="row">
  @if (row.quoteReference && row.executionContextType === 'genericMultiHedge') {
    <span class="hedge-quotes">
      <span *ngFor="let hedge of row.hedgeQuotes | sortHedgeQuotes">
        @if (hedge.hedgeIsDX) {
          Client {{ hedge.hedgeDirection + 's' }}
        } @else {
          {{ parent | uppercase }}
          {{ hedge.hedgeDirection === 'Buy' ? 'Sells' : 'Buys' }}
        }
        {{ hedge.hedgeCurrency }} {{ hedge.hedgeAmount | number: '0.0-0' }} at
        <app-number-highlighter
          [value]="hedge.hedgeRate | strikeFormatter: cross"
          [startAfterDecimal]="true"
          [indicesToHighlight]="pipsHighlightedIndices"
        ></app-number-highlighter>
        {{ hedge.hedgeDeliveryDate | date: 'dd MMM yyyy' }}
      </span>
    </span>
  }
</ng-template>

<!-- RFQ BUTTON -->
<ng-template #rfqButton let-row="row" let-type="type" let-i="i">
  <span class="rfq-button-container">
    <button
      class="ui-button ui-button--rounded ui-button--flex rfq-button {{
        row.status || ''
      }}"
      [ngClass]="{
        primary: i === 0,
        'hedge-custom-amount-mismatch': hedgeCustomAmountMismatch(),
        selected:
          rfqRequestActionStatus?.bank === row.bank &&
          rfqRequestActionStatus?.type === type,
        'indicative-quote': row.status === 'Indicative' || disabled,
        outdated: row.outdated
      }"
      (mousedown)="rfeRequest(row)"
      (keydown)="rfeRequestKeydown($event, row)"
      [disabled]="
        disabled ||
        hedgeCustomAmountMismatch() ||
        row.status !== 'Default' ||
        !rfqRunning ||
        (showTopBookOnly && i !== 0) ||
        row.outdated
      "
    >
      <div class="rfq-button__text-container">
        <ng-container *ngIf="volBased && row.bidAsksByDate">
          <span
            class="bank-button-text__top"
            *ngFor="let volrow of row.bidAsksByDate"
          >
            <span class="bank-button-text" *ngIf="volrow.type">
              {{ volrow.type }}:
            </span>
            <span class="bank-button-text">
              {{ volrow.currency }}
              {{ formatPremium(volrow.amount, row.premiumStyle, true) }}
              on {{ volrow.date }}
            </span>
          </span>
        </ng-container>
        <span class="bank-button-text__top" *ngIf="!volBased">
          <span
            class="bank-button-text bank-button-text--bold bank-button-text--large"
            *ngIf="row.bidAsk.type === 'Pay'"
          >
            Client pays:
          </span>
          <span
            class="bank-button-text bank-button-text--bold bank-button-text--large"
            *ngIf="row.bidAsk.type === 'Receive'"
          >
            Client receives:
          </span>
          <span class="bank-button-text bank-button-text--bold">
            {{ row.bidAsk?.currency }}
          </span>
          <span
            class="bank-button-text bank-button-text--bold  bank-button-text--{{
              row.bidAsk?.color
            }}"
          >
            {{ row.bidAsk?.amount | number: '1.0-0' }}
            @if (row.status === 'Indicative') {
              (Indic.)
            }
          </span>
          <span
            class="bank-button-text bank-button-text--bold  bank-button-text--{{
              row.bidAsk?.color
            }}"
            *ngIf="row.bidAsk.marginSpread"
          >
            ({{ row.bidAsk.marginSpread | percent: '1.4-4' }})
          </span>
        </span>

        <ng-container *ngTemplateOutlet="singleProviderVolTmpl"></ng-container>

        @if (
          useSingleProviderDetailedView ||
          !(indicativePremiumStyle && row?.indicativePremium)
        ) {
          <ng-container *ngTemplateOutlet="premiumSectionTmpl"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="indicativePremium"></ng-container>
        }
        <ng-container *ngIf="volBased">
          <ng-container
            *ngTemplateOutlet="
              volBasedPremium;
              context: {
                currency: row.quotedPremiumSection?.currency,
                premium: row.legPremium
              }
            "
          ></ng-container>
        </ng-container>
      </div>
    </button>

    <ng-container
      *ngTemplateOutlet="hedgeQuotes; context: { row: row }"
    ></ng-container>

    @if (nonDxExists) {
      <div
        class="hedge-data"
        [ngClass]="{
          'hedge-data--show': hedge !== 'None'
        }"
        *ngIf="row.hedge?.type && singleProviderDXState() === 'SHOW_EXECUTE'"
      >
        {{ parent | uppercase }}
        {{ invertDirection(row.hedge.type).toLowerCase() }}s
        {{ row.hedge?.currency }}
        <ng-container
          *ngIf="row.hedge?.amount !== undefined && !isNaN(row.hedge?.amount)"
        >
          {{ row.hedge?.amount | abs | number: '1.0-0' }}
        </ng-container>

        <span class="hedge-data__value" *ngIf="row.hedge?.value">
          &#64;<app-number-highlighter
            [startAfterDecimal]="true"
            [value]="row.hedge?.value | strikeFormatter: cross"
            [indicesToHighlight]="pipsHighlightedIndices"
          ></app-number-highlighter>
        </span>
      </div>
    } @else {
      <div
        class="hedge-data"
        [ngClass]="{
          'hedge-data--show': hedge !== 'None'
        }"
        *ngIf="row.hedge?.type"
      >
        @if (singleProviderDXState() === 'SHOW_CLIENT') {
          Client {{ row.hedge.type.toLowerCase() }}s
        } @else {
          {{ row.hedge.type }}
        }
        <ng-container
          *ngIf="row.hedge?.amount !== undefined && !isNaN(row.hedge?.amount)"
        >
          {{ row.hedge?.amount | abs | number: '1.0-0' }}
        </ng-container>

        {{ row.hedge?.currency }}
        <span class="hedge-data__value" *ngIf="row.hedge?.value">
          &#64;<app-number-highlighter
            [startAfterDecimal]="true"
            [value]="row.hedge?.value | strikeFormatter: cross"
            [indicesToHighlight]="pipsHighlightedIndices"
          ></app-number-highlighter>
        </span>
      </div>
    }
  </span>
</ng-template>

<!-- PROVIDER NAME STATUS -->
<ng-template #providerNameStatus let-side="side" let-row="row">
  <span
    class="table-row__data-box table-row__data-box--sub table-row__data-box--sub--provider-name-status"
  >
    <ng-container *ngIf="showBank">
      <span class="table-row__bank">
        <ng-container *ngIf="side === 'offer'">
          {{ row.bank }}
        </ng-container>
        <img
          src="assets/info.svg"
          *ngIf="!!row.description"
          (click)="doShowDescription(row, side)"
        />
        <ng-container *ngIf="side === 'bid'">
          {{ row.bank }}
        </ng-container>
      </span>
    </ng-container>
  </span>
</ng-template>

<ng-template #indicativePremium>
  <span class="bank-button-text">
    {{
      indicativePremiumStyle
        | indicativePremium
          : row
          : side
          : forwardPointsMultiplier
          : baseCurrency
          : termCurrency
    }}
  </span>
</ng-template>

<ng-template #singleProviderVolTmpl>
  <span
    class="bank-button-text"
    *ngIf="
      useSingleProviderDetailedView && row.vol?.[position] && showVols[position]
    "
  >
    @if (position === 'left' && row.vol[position].length >= 5) {
      <ng-container
        *ngTemplateOutlet="volsTooltip; context: { row: row }"
      ></ng-container>
    }
    @for (vol of row.vol[position]; track $index) {
      @if ($index === 0) {
        Vol.&nbsp;{{
          row.vol[position][$index]?.value * 100 | zeroNumberFormatter: '1.3-3'
        }}
      } @else if ($index === 4) {
        /...
      } @else if ($index > 4) {
      } @else {
        /&nbsp;{{
          row.vol[position][$index]?.value * 100 | zeroNumberFormatter: '1.3-3'
        }}
      }
    }
    @if (position === 'right' && row.vol[position].length >= 5) {
      <ng-container
        *ngTemplateOutlet="volsTooltip; context: { row: row }"
      ></ng-container>
    }
  </span>
</ng-template>

<ng-template #volsTooltip let-row="row">
  <clr-tooltip>
    <span clrTooltipTrigger>
      <cds-icon shape="info-circle"></cds-icon>
      <clr-tooltip-content
        [clrPosition]="position === 'left' ? 'right' : 'left'"
        [clrSize]="'md'"
      >
        Vols:
        @for (vol of row.vol[position]; track $index) {
          {{ row.vol[position][$index].value * 100 | number: '1.3-3' }}
          @if (!$last) {
            /&nbsp;
          }
        }
      </clr-tooltip-content>
    </span>
  </clr-tooltip>
</ng-template>

<ng-template #premiumSectionTmpl>
  <span class="bank-button-text">
    @if (useSingleProviderDetailedView) {
      @if (
        row.premiumCurrency === baseCurrency ||
        row.premiumCurrency === termCurrency
      ) {
        {{ row.premiumInPercent | abs | percent: '1.4-4' }}
      }

      @if (row.premiumCurrency === termCurrency) {
        @if (row.premiumInPercent != null) {
          &nbsp;/&nbsp;
        }
        @if (row.pips != null) {
          {{ row.pips | abs | number: '1.2-2' }}&nbsp;pips
        }
      }
    } @else if (
      row.quotedPremiumSection?.quotedPremium &&
      (row.quotedPremiumSection?.currency || row.quotedPremiumSection?.isPips)
    ) {
      {{
        row.quotedPremiumSection?.quotedPremium
          | abs
          | number: (row.quotedPremiumSection.showPercent ? '1.3-3' : '1.1-1')
      }}{{ row.quotedPremiumSection.showPercent ? '%' : '' }}&nbsp;{{
        row.quotedPremiumSection?.isPips
          ? 'pips'
          : row.quotedPremiumSection?.currency
      }}
    }
  </span>
</ng-template>
